"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
require("fancybox/dist/js/jquery.fancybox");
require("fancybox/dist/css/jquery.fancybox.css");
$.extend($.fancybox, {
    // Start closing animation if is open; remove immediately if opening/closing
    close: function (event) {
        $.fancybox.cancel();
        if (false === $.fancybox.trigger('beforeClose')) {
            return;
        }
        $.fancybox.unbindEvents();
        if (!$.fancybox.isActive) {
            return;
        }
        if (!$.fancybox.isOpen || event === true) {
            $('.fancybox-wrap').stop(true).trigger('onReset').remove();
            $.fancybox._afterZoomOut();
        }
        else {
            $.fancybox.isOpen = $.fancybox.isOpened = false;
            $.fancybox.isClosing = true;
            $('.fancybox-item, .fancybox-nav').remove();
            if ($('.fancybox-overlay').hasClass('modal-backdrop')) {
                $('.fancybox-overlay').removeClass('in');
            }
            $('.modal-dialog').animate({
                top: "-=250",
                opacity: 0
            }, 250, function () {
                $.fancybox.wrap.stop(true, true).removeClass('fancybox-opened');
            });
            $.fancybox.transitions[$.fancybox.current.closeMethod]();
        }
    },
    hideLoading: function () {
        $('#fancybox-loading').fadeOut(500, function () {
            $('#fancybox-loading').remove();
        });
    },
    showLoading: function () {
        var el, viewport;
        el = $('<div id="fancybox-loading"><div></div></div>').on('click', $.fancybox.cancel).appendTo('body');
        // Quick Fix: Do not attach throbber for Safari because it causes a complete freeze
        // in combination with active scriptmerger
        // ToDo: Find and resolve causation
        var agent = navigator.userAgent.toLowerCase();
        if (agent.indexOf('safari') < 0) {
            $('#fancybox-loading').attachThrobber();
        }
        // If user will press the escape-button, the request will be canceled
        $(document).on('keydown.loading', function (e) {
            if ((e.which || e.keyCode) === 27) {
                e.preventDefault();
                $.fancybox.cancel();
            }
        });
        if (!$.fancybox.defaults.fixed) {
            viewport = $.fancybox.getViewport();
            el.css({
                position: 'absolute',
                top: (viewport.h * 0.5) + viewport.y,
                left: (viewport.w * 0.5) + viewport.x
            });
        }
    }
});
$.extend($.fancybox.defaults, {
    beforeLoad: function () {
        // close all tooltips to prevent z-index hassle
        $('.tooltipstered').tooltipster('hide');
    }
});
/**
 * Close every fancybox from link in general
 * Just add css class close-lightbox-link to link
 * Delegate because element is in probably no way existant in default markup
 */
$('body').on('click', '.close-lightbox-link', function (event) {
    event.preventDefault();
    if ($.fancybox.isOpen) {
        $.fancybox.close();
    }
    else {
        // hotfix: must be set dynamically
        window.location.href = '/gs1-consult/fachpublikationen/';
    }
});
$(function () {
    (function ($, F) {
        /*
         * is used as an alternative opening function for fancybox to prevent any animation
         */
        F.transitions.modalIn = function () {
            if (F.helpers.overlay.overlay.hasClass("modal-backdrop") === false) {
                F.helpers.overlay.overlay.addClass("modal-backdrop fade");
            }
            F.helpers.overlay.overlay.addClass("in");
            F.wrap.appendTo("#main");
            F._afterZoomIn();
        };
        /*
         * is used as an alternative opening function for fancybox to prevent any animation
         */
        F.transitions.galleryIn = function () {
            if (F.helpers.overlay.overlay.hasClass("modal-backdrop") === false) {
                F.helpers.overlay.overlay.addClass("modal-backdrop fade");
            }
            F.helpers.overlay.overlay.addClass("in");
            F.wrap.appendTo("#main");
            $(".modal-dialog").addClass(".no-fade");
            F._afterZoomIn();
        };
    })(jQuery, jQuery.fancybox);
});
exports.default = {};
